import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';

export const ExceptionsType = ({ itemType, message }) => {

  return (
    <>
      <Typography variant="body-base" weight="bold">{itemType}</Typography>
      <Typography variant="body-xs" color="subtle">{message}</Typography>
    </>
  );
};

ExceptionsType.displayName = 'ExceptionsType';

ExceptionsType.propTypes = {
  itemType: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired
};